module.exports = __webpack_public_path__ + "img/game_mg.d9cd6387.png";